module.exports = __webpack_public_path__ + "media/images/players/SWAFFORD_HUDSON-72464719b37480430bd14b43bf91cd97.png";